import { parseBooleanFromString } from './boolean';

export const isDev =
  (typeof import.meta !== 'undefined' &&
    import.meta.env &&
    (import.meta.env.DEV ||
      parseBooleanFromString(import.meta.env.VITE_TEST))) ||
  false;

export const isTest: boolean =
  (typeof import.meta !== 'undefined' &&
    import.meta.env &&
    parseBooleanFromString(import.meta.env.VITE_TEST)) ||
  false;
